// extracted by mini-css-extract-plugin
export default {"page":"rI0Bf","layout":"gRQQW","main":"t7LVi","player":"nOaiE"};